/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import { Theme, getBodyStyle, getColor } from 'styles/theme';

export const Wrapper = styled.div<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'default', mdMin: 'large' }, 'semiBold')};
  max-width: 100%;
  display: flex;
`;

export const IndexInfo = styled.span<{ theme: Theme }>`
  color: ${getColor('textPrimary')};
  padding-right: 24px;
  border-right: 1px solid ${getColor('borderSecondary')};
  display: flex;
  align-items: center;

  @media (${breakpoint.mdMin}) {
    padding-right: 16px;
    color: ${getColor('textSecondary')};;
  }
`;

export const Title = styled.span`
  padding-left: 24px;

  @media (${breakpoint.mdMin}) {
    padding-left: 16px;
  }

  a {
    line-height: 24px;
    letter-spacing: 0.5px;
    font-weight: 600;
  }
`;
